import ContextMenu from '../ContextMenu/index.vue'
import { debounce } from '@/utils/index'

const ContextMenuMixin = {
  components: {
    ContextMenu
  },
  props: {
    contextMenuMap: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      contextMenu: {
        visible: false,
        position: { x: 0, y: 0 },
        items: [
          {
            text: '确认',
            icon: 'el-icon-thumb',
            shortcut: 'Enter',
            visible: true
          },
          {
            text: '查询',
            icon: 'el-icon-search',
            shortcut: 'Ctrl+F',
            visible: true
          },
          {
            text: '上传',
            icon: 'el-icon-plus',
            shortcut: 'Insert',
            visible: true
          },
          {
            text: '插入',
            icon: 'el-icon-plus',
            shortcut: 'Insert',
            visible: true
          },
          {
            text: '插入下级',
            icon: 'el-icon-plus',
            shortcut: 'Insert',
            visible: true
          },
          {
            text: '插入剪切板内容',
            icon: 'el-icon-plus',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },
          {
            text: '插入分部',
            icon: 'el-icon-plus',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },
          {
            text: '插入清单子目',
            icon: 'el-icon-plus',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },
          // { divider: true },
          {
            text: '批量修改',
            icon: 'el-icon-edit',
            shortcut: 'Ctrl+G',
            visible: true
          },
          // { divider: true },
          // {
          //   text: '复制本表',
          //   icon: 'el-icon-copy-document',
          //   shortcut: 'Ctrl+C',
          //   visible: true
          // },
          {
            text: '拷贝行',
            icon: 'el-icon-copy-document',
            shortcut: 'Ctrl+Alt+C',
            visible: true
          },
          {
            text: '插入拷贝行',
            icon: 'el-icon-plus',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },
          {
            text: '拷贝本表+子表',
            icon: 'el-icon-copy-document',
            shortcut: 'Ctrl+Alt+C',
            visible: true
          },
          {
            text: '插入本表+子表',
            icon: 'el-icon-plus',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },

          // {
          //   text: '粘贴单元格',
          //   icon: 'el-icon-document-copy',
          //   shortcut: 'Ctrl+Shift+C',
          //   visible: true
          // },
          {
            text: '树形结构生成',
            icon: 'el-icon-ship',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },
          {
            text: '列表显示',
            icon: 'el-icon-view',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },
          {
            text: '树形显示',
            icon: 'el-icon-view',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },
          {
            text: '选择模版',
            icon: 'el-icon-search',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },
          {
            text: '保存模版',
            icon: 'el-icon-postcard',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },
          {
            text: '计算金额',
            icon: 'el-icon-receiving',
            shortcut: 'Ctrl+Shift+C',
            visible: true
          },
          // {
          //   text: '粘贴',
          //   icon: 'el-icon-document-copy',
          //   shortcut: 'Ctrl+V',
          //   visible: true
          // },
          // {
          //   text: '复制单元格',
          //   icon: 'el-icon-copy-document',
          //   shortcut: 'Ctrl+Shift+C',
          //   visible: true
          // }
          {
            text: '批量删除',
            icon: 'el-icon-delete',
            shortcut: 'Delete',
            visible: true
          },
          {
            text: '导出',
            icon: 'el-icon-sold-out',
            shortcut: 'Delete',
            visible: true
          },
          {
            text: '部分组价',
            icon: 'el-icon-coordinate',
            shortcut: 'Delete',
            visible: true
          },
          {
            text: '部分调价',
            icon: 'el-icon-coordinate',
            shortcut: 'Delete',
            visible: true
          }
        ],
        args: null
      }
    }
  },
  watch: {},
  methods: {
    // 绑定canvas右键事件
    bindCanvasContextMenu() {
      if (!this.tableInstance || !this.$refs.tableContainer) return

      // 获取VTable的canvas元素
      const canvasElement = this.$refs.tableContainer.querySelector('canvas')
      if (!canvasElement) return

      // 添加右键事件监听
      canvasElement.addEventListener('contextmenu', this.contextMenuEvent)
    },

    contextMenuEvent(event) {
      const canvasElement = this.$refs.tableContainer.querySelector('canvas')
      // 阻止默认右键菜单
      event.preventDefault()
      event.stopPropagation()

      // 获取点击位置相对于canvas的坐标
      const rect = canvasElement.getBoundingClientRect()
      const x = event.clientX - rect.left
      const y = event.clientY - rect.top

      // 尝试获取点击位置的单元格信息
      let cellInfo = null
      try {
        cellInfo = this.tableInstance.getCellAtRelativePosition(x, y)
      } catch (error) {
        console.log('无法获取单元格信息，显示通用右键菜单')
      }

      // 构造事件参数
      const args = {
        event: event,
        clientX: event.clientX,
        clientY: event.clientY,
        x: x,
        y: y,
        col: cellInfo?.col ?? -1,
        row: cellInfo?.row ?? -1,
        field:
          cellInfo.row > 0
            ? this.tableInstance?.getBodyField(cellInfo.col, cellInfo.row)
            : null,
        value: cellInfo?.value || null
      }

      // 显示右键菜单
      this.showContextMenu(args)
    },

    // 接触绑定canvas右键事件
    unbindCanvasContextMenu() {
      if (!this.tableInstance || !this.$refs.tableContainer) return

      // 获取VTable的canvas元素
      const canvasElement = this.$refs.tableContainer.querySelector('canvas')
      if (!canvasElement) return

      canvasElement.removeEventListener('contextmenu', this.contextMenuEvent)
    },

    // 右键菜单相关方法
    /**
     * 显示右键菜单
     * @param {Object} args - 右键事件参数
     */
    showContextMenu: function (args) {
      // 如果点击的是表头或操作列就不显示右键菜单（仅对单元格事件有效）
      if (args.row === 0 || args.field === 'operation') {
        // 但如果是canvas事件（row为-1），则允许显示
        if (args.row !== -1) return
      }

      // 阻止默认右键菜单和事件冒泡
      if (args.event) {
        args.event.preventDefault()
        args.event.stopPropagation()
      }
      this.mergeContextMenuMap(args)
      if (this.contextMenu.items.length === 0) return

      // 优先使用clientX/clientY，如果没有则使用event中的坐标
      const clientX = args.clientX || args.event?.clientX || 0
      const clientY = args.clientY || args.event?.clientY || 0

      this.contextMenu.position = {
        x: clientX,
        y: clientY
      }
      this.contextMenu.args = args
      this.contextMenu.visible = true
    },

    mergeContextMenuMap(args) {
      const contextMenuMap = { ...this.contextMenuMap }
      const isMultipleCol = this.tableInstance
        .getSelectedCellInfos()
        .some(cells => cells.length > 1)

      if (!contextMenuMap || Object.keys(contextMenuMap).length === 0) {
        this.contextMenu.items = []
        return
      }

      const cell = this.tableInstance.getCellInfo(args.col, args.row)
      if (!cell?.originData) {
        contextMenuMap['批量修改'] = null
        contextMenuMap['批量删除'] = null
      }

      const column = this.getColumnConfig(args)

      if (
        (!column?.customConfig?.canModify || isMultipleCol) &&
        contextMenuMap['批量修改']
      ) {
        contextMenuMap['批量修改'] = null
      }

      for (const val of this.contextMenu.items) {
        val.visible = !!contextMenuMap[val.text]
        val.click = contextMenuMap[val.text]
      }
    },

    /**
     * 隐藏右键菜单
     */
    hideContextMenu() {
      this.contextMenu.visible = false
      this.contextMenu.currentCell = null
    },

    handleContextMenuClick() {
      this.hideContextMenu()
    }
  }
}

export { ContextMenuMixin }
